import React from 'react';
import { useWatch } from 'react-hook-form';

export const OrderEmpty = () => {
    const items = useWatch({ name: 'items' });
    if (items?.length > 0) return null;

    return (
        <div className='empty-page-sec'>
            <div className='empty-page-title'>No tasks yet.</div>
            <div className='empty-page-message'>Once a task has been created, it will appear here.</div>
        </div>
    );
};
